export const readerFontOptions = [
  { value: "serif", label: "默认" },
  { value: "'Noto Serif SC', serif", label: "宋体" },
  { value: "'Noto Sans SC', sans-serif", label: "黑体" },
  { value: "'LXGW WenKai', serif", label: "霞鹜文楷" },
  { value: "'Source Han Serif SC', serif", label: "思源宋体" },
];
